<template>
  <div class="page">
    <mt-header :title="this.$t('认证状态')">
      <mt-button icon="back" slot="left" @click="$router.back()"></mt-button>
    </mt-header>

    <div class="content" v-if="this.$route.query.status == 3">
      <div><img src="@/assets/img/realname/wrong.png" /></div>
      <span class="textstyle">{{ $t("身份认证失败") }}</span>

      <article class="artstylewrong">
        <div>
          <span style="color: red">{{ $t("失败原因") }}</span>
        </div>
        <div style="margin-top: 35px; color: red">
          <span>{{ info.refuse_content }}</span>
        </div>
      </article>
      <button class="btnwrong" @click="$router.push('/levelThree')">
        {{ $t("重新认证") }}
      </button>
    </div>
    <div class="content" v-if="this.$route.query.status == 2">
      <div><img src="@/assets/img/realname/reviewing.png" /></div>
      <span class="textstyle">{{ $t("审核中") }}</span>
      <!-- 待审核直接显示头像和文字说明 没按钮 -->
    </div>
    <div class="content" v-if="this.$route.query.status == 1">
      <div><img src="@/assets/img/realname/reviewed.png" /></div>
      <span class="textstyle">{{ $t("已完成身份认证") }}</span>
      <article class="succeed">
        <div class="detail">
          <span>{{ $t("姓名") }}</span> <span>{{ info.u_name }}</span>
        </div>
        <div class="detail">
          <span>{{ $t("国籍") }}</span> <span>{{ info.country }}</span>
        </div>
        <div class="detail">
          <span>{{ $t("类型") }}</span>
          <span v-if="info.kind == 'idcard'">{{ $t("身份证") }}</span>
          <span v-if="info.kind == 'passport'">{{ $r("护照") }}</span>
          <span v-if="info.kind == 'driving_licence'">{{ $t("驾照") }}</span>
        </div>
        <div class="detail">
          <span>{{ $t("证件号码") }}</span> <span>{{ info.photo_id }}</span>
        </div>
      </article>
      <!-- 成功 -->

      <button class="btnend">{{ $t("已完成实名认证") }}</button>
    </div>

    <article></article>
  </div>
</template>

<script>
import { httpGetAuthInfo } from "@/api/index";
export default {
  data() {
    return {
      info: {},
    };
  },
  activated() {
    // 展示用户实名认证信息
    httpGetAuthInfo()
      .then((res) => {
        this.info = res.data;
      })
      .catch();
  },
  deactivated() {
    this.info = {};
  },
  methods: {},
};
</script>

<style lang="less" scoped>
#app .mint-header {
  background-color: #fff;
  color: #1d3d57;
  box-shadow: 0px -1px 5px #e3e3e3;
}

.content {
  display: flex;
  flex-direction: column;
  padding-top: 5rem;
  align-items: center;
}
.textstyle {
  font-weight: 600;
  margin-top: 7px;
  text-align: center;
}
.artstylewrong {
  width: 80%;
  height: 200px;
  box-sizing: border-box;
  margin-top: 30px;
  padding: 30px;
  text-align: center;
  background-color: #fff0f0;
  border-radius: 10px;
}
.succeed {
  width: 80%;
  height: 200px;
  box-sizing: border-box;
  margin-top: 30px;
  padding: 10px 20px;
  background-color: #e0f1f4;
  border-radius: 10px;
  font-size: smaller;

  .detail {
    display: flex;
    justify-content: space-between;
    margin: 15px 0;
    line-height: 25px;
  }
}
.btnend {
  width: 90%;
  height: 40px;
  position: fixed;
  bottom: 20px;
  border-radius: 20px;
  color: #fff;
  background-color: #a3b3b7;
}
.btnwrong {
  width: 90%;
  height: 40px;
  position: fixed;
  bottom: 20px;
  border-radius: 20px;
  color: #fff;
  background-color: #2a7d92;
}
</style>
